import { render, staticRenderFns } from "./workorders.vue?vue&type=template&id=209409fb&"
import script from "./workorders.vue?vue&type=script&lang=js&"
export * from "./workorders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports